import type { ReactNode } from 'react';

export const symbol_approval: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24.75 0-42.37-17.63Q160-115.25 160-140v-200q0-24 18-42t42-18h520q24 0 42 18t18 42v200q0 24.75-17.62 42.37Q764.75-80 740-80H220Zm50-160h420q21.25 0 35.63-14.32Q740-268.65 740-289.82q0-21.18-14.37-35.68Q711.25-340 690-340H270q-21.25 0-35.62 14.32Q220-311.35 220-290.18q0 21.18 14.38 35.68Q248.75-240 270-240Zm186-194L295-660q-7-10-9.5-21.21-2.5-11.22-.5-22.79 12-76 63-126t132-50q81 0 132 50t63 126q2 11.57-.5 22.79Q672-670 665-660L504-434q-8.67 13-23.83 13Q465-421 456-434Zm24-44 139-202q0-58.33-40.56-99.17Q537.88-820 479.94-820t-98.44 40.83Q341-738.33 341-680l139 202Zm0-171Z"
		/>
	</svg>
);
